const sing = [

  // =========================
  // A7 LUNO
  // =========================
{
  id: "singlet-a7-luno-stealth",
  slug: "singlet-a7-luno-stealth",
  name: "Singlet A7 Luno Stealth",
  category: "singlets",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  bestSeller: true,
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-stealth.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-stealth-wom.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
}
,
{
  id: "singlet-a7-luno-shadow-stone-grey",
  slug: "singlet-a7-luno-shadow-stone-grey",
  name: "Singlet A7 Luno Shadow Stone Grey",
  brand: "A7",
  category: "singlets",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-grey.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-grey-wom.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-luno-shadow-stone",
  slug: "singlet-a7-luno-shadow-stone",
  name: "Singlet A7 Luno Shadow Stone",
  category: "singlets",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-shst.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-shst-wom.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-luno-gold-standard",
  slug: "singlet-a7-luno-gold-standard",
  name: "Singlet A7 Luno Gold Standard",
  category: "singlets",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-gs.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-gs-wom.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-luno-red-dawn",
  slug: "singlet-a7-luno-red-dawn",
  category: "singlets",
  name: "Singlet A7 Luno Red Dawn",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-rd.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-rd-wom.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-luno-ivory-rose",
  slug: "singlet-a7-luno-ivory-rose",
  name: "Singlet A7 Luno Ivory Rose",
  category: "singlets",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-ivo-men.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-ivo.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-luno-violet",
  slug: "singlet-a7-luno-violet",
  category: "singlets",
  name: "Singlet A7 Luno Violet",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-vio-men.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-vio.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-luno-polar",
  category: "singlets",
  slug: "singlet-a7-luno-polar",
  name: "Singlet A7 Luno Polar",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-po-men.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-po.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-luno-emerald",
  slug: "singlet-a7-luno-emerald",
  name: "Singlet A7 Luno Emerald",
  category: "singlets",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  brand: "A7",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-esm-men.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-esm.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-luno-domino",
  slug: "singlet-a7-luno-domino",
  name: "Singlet A7 Luno Domino",
  brand: "A7",
  category: "singlets",
  sizeGuide: "/Guias/sg-sing-luno.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-dom-men.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-wb.webp",
      price: 139.5, oldPrice: 155,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},


  // =========================
  // A7 RAUSCH
  // =========================
{
  id: "singlet-a7-rausch-gold-standard",
  category: "singlets",
  slug: "singlet-a7-rausch-gold-standard",
  name: "Singlet A7 Rausch Gold Standard",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-rau.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-rau-gs.webp",
      price: 167.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-rau-gs-wom.webp",
      price: 167.5,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-rausch-dusk",
  category: "singlets",
  slug: "singlet-a7-rausch-dusk",
  name: "Singlet A7 Rausch Dusk",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-rau.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-rau-dusk.webp",
      price: 167.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-rau-dusk-wom.webp",
      price: 167.5,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-rausch-aurora",
  category: "singlets",
  slug: "singlet-a7-rausch-aurora",
  name: "Singlet A7 Rausch Aurora",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-rau.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-rau-aur.webp",
      price: 167.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-rau-aur-wom.webp",
      price: 167.5,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-rausch-usa",
  category: "singlets",
  slug: "singlet-a7-rausch-usa",
  name: "Singlet A7 Rausch USA",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-rau.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-usa.webp",
      price: 175,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-usa-wom.webp",
      price: 175,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-rausch-tides-blue",
  category: "singlets",
  slug: "singlet-a7-rausch-tides-blue",
  name: "Singlet A7 Rausch Tides Blue",
  brand: "A7",
  sizeGuide: "/Guias/sg-sing-rau.webp",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-tid-bl.webp",
      price: 167.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-tid-bl-wom.webp",
      price: 167.5,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},
{
  id: "singlet-a7-rausch-tides-white",
  category: "singlets",
  slug: "singlet-a7-rausch-tides-white",
  name: "Singlet A7 Rausch Tides White",
  sizeGuide: "/Guias/sg-sing-rau.webp",
  brand: "A7",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-a7-tid-wh-men.webp",
      price: 167.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-a7-tid-wh.webp",
      price: 167.5,
      sizes: ["2XS","XS","S","M","L","XL","2XL","3XL"]
    }
  ]
},


  // =========================
  // A7 CLASSIC MODELS
  // =========================
  {
    id: "singlet-a7-black",
    category: "singlets",
    slug: "singlet-a7-black",
    name: "Singlet A7 Black",
    brand: "A7",
    sizeGuide: "/Guias/sg-sing-luno.webp",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    variants: [
      { image: "/Productos/singlet-a7-bw.webp", price: 132.75, oldPrice: 147.5, }
    ],
  },
  {
    id: "singlet-a7-stealth-classic",
    slug: "singlet-a7-stealth-classic",
    category: "singlets",
    name: "Singlet A7 Stealth",
    sizeGuide: "/Guias/sg-sing-luno.webp",
    brand: "A7",
    sizes: ["XS", "S", "M", "L", "XL", "2XL"],
    variants: [
      { image: "/Productos/singlet-a7-b.webp", price: 132.75, oldPrice: 147.5, }
    ],
  },

  // =========================
  // SBD
  // =========================
  {
  id: "singlet-sbd-classic",
  slug: "singlet-sbd-classic",
  name: "Singlet SBD Classic",
  category: "singlets",
  sizeGuide: "/Guias/sg-sing-sbd.png",
  brand: "SBD",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/singlet-sbd.webp",
      price: 182.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-sbd-wom.webp",
      price: 182.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    }
  ]
},
{
  id: "singlet-sbd-serenity",
  slug: "singlet-sbd-serenity",
  name: "Singlet SBD Serenity",
  category: "singlets",
  sizeGuide: "/Guias/sg-sing-sbd.png",
  brand: "SBD",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-sbd-ser.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-sbd-ser-wom.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    }
  ]
},
{
  id: "singlet-sbd-resolve",
  slug: "singlet-sbd-resolve",
  name: "Singlet SBD Resolve",
  category: "singlets",
  sizeGuide: "/Guias/sg-sing-sbd.png",
  brand: "SBD",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-sbd-res.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-sbd-res-wom.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    }
  ]
},
{
  id: "singlet-sbd-aspire",
  slug: "singlet-sbd-aspire",
  name: "Singlet SBD Aspire",
  sizeGuide: "/Guias/sg-sing-sbd.png",
  category: "singlets",
  brand: "SBD",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-sbd-asp.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-sbd-asp-wom.jpg",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    }
  ]
},
{
  id: "singlet-sbd-forge-grey",
  slug: "singlet-sbd-forge-grey",
  sizeGuide: "/Guias/sg-sing-sbd.png",
  name: "Singlet SBD Forge Grey",
  category: "singlets",
  brand: "SBD",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-sbd-for-grey-men.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-sbd-for-grey.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    }
  ]
},
{
  id: "singlet-sbd-forge-orange",
  category: "singlets",
  slug: "singlet-sbd-forge-orange",
  name: "Singlet SBD Forge Orange",
  sizeGuide: "/Guias/sg-sing-sbd.png",
  brand: "SBD",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-sbd-for-nar.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-sbd-for-nar-wom.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    }
  ]
},
{
  id: "singlet-sbd-nova",
  slug: "singlet-sbd-nova",
  name: "Singlet SBD Nova",
  sizeGuide: "/Guias/sg-sing-sbd.png",
  brand: "SBD",
  category: "singlets",
  variants: [
    {
      gender: "Hombre",
      image: "/Productos/sing-sbd-nova-men.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    },
    {
      gender: "Mujer",
      image: "/Productos/sing-sbd-nova.webp",
      price: 187.5,
      sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"]
    }
  ]
},
{
  id: "singlet-sbd-2019",
  slug: "singlet-sbd-2019",
  name: "Singlet SBD Version 2019",
  sizeGuide: "/Guias/sg-sing-sbd.png",
  category: "singlets",
  brand: "SBD",
  image: "/Productos/sing-sbd-2019.webp",
  sizes: ["XS","S","M","L","XL","2XL","3XL","4XL","5XL"],
  variants: [{ price: 187.5 }],
},

  {
    id: "singlet-gymshark",
    category: "singlets",
    slug: "singlet-gymshark",
    name: "Singlet GymShark Seamless",
    brand: "GYMSHARK",
    sizes: ["XXS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
    variants: [
      { image: "/Productos/sing-gshark.webp", price: 146 }
    ],
  },
  // =========================
  // INDIVIDUALES
  // =========================
    {
    id: "inzer-singlet",
    slug: "singlet-inzer",
    name: "Singlet Inzer",
    category: "singlets",
    sizeGuide: "/Guias/sg-sing-inzer.png",
    brand: "INZER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL","4XL", "5XL"],
    variants: [
      { image: "/Productos/singlet-inzer.webp", price: 115 }
    ],
  },
  {
    id: "inzer-power",
    category: "singlets",
    slug: "singlet-inzer-power",
    name: "Singlet Inzer Power",
    sizeGuide: "/Guias/sg-sing-inz.png",
    brand: "INZER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL","4XL", "5XL"],
    variants: [
      { image: "/Productos/sing-inz-power.webp", price: 160 }
    ],
  },


  {
    id: "pioneer-classic",
    category: "singlets",
    slug: "singlet-pioneer",
    name: "Singlet Pioneer",
    brand: "PIONEER",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [
      { image: "/Productos/pio-sing-nuevo.png", price: 130 }
    ],
  },

  {
    id: "pioneer-phantom",
    category: "singlets",
    slug: "singlet-pioneer-phantom",
    name: "Singlet Pioneer Phantom",
    brand: "PIONEER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [
      { image: "/Productos/sing-pio-nuevo-ph.jpg", price: 140 }
    ],
  },

  {
    id: "stoic-singlet",
    category: "singlets",
    slug: "singlet-stoic",
    name: "Singlet Stoic",
    brand: "STOIC",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
    variants: [
      { image: "/Productos/sing-stoic.webp", price: 140 }
    ],
  },

  {
    id: "strengthshop-singlet",
    category: "singlets",
    slug: "singlet-strengthshop",
    name: "Singlet Strengthshop",
    brand: "STRENGHTSHOP",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [
      { image: "/Productos/sing-str.webp", price: 130 }
    ],
  },

];

export default sing;
